import { IBoundingBoxModel } from 'src/app/core/models/models';
import { GoogleMapType, MarkerType } from '../enums/google-map-enum';
import { IGoogleMap, ILatLng } from 'src/app/core/models/google-map-models';
import { IHybridGoogleMap } from './interface/hybrid-google-map-interface';
import { HybridGoogleMap } from './hybrid-google-map';

export class GoogleMapStoreModel {
    mapType: GoogleMapType;
    googleMap: IGoogleMap;
    mapInstance: HybridGoogleMap;

    constructor(mapType: GoogleMapType, googleMap: IGoogleMap, mapInstance: HybridGoogleMap) {
        this.mapType = mapType;
        this.googleMap = googleMap;
        this.mapInstance = mapInstance;
    }
  }

export class GoogleMapOptionsModel {
    CarPark: boolean;
    TrafficAlert: boolean;
    CurrentTraffic: boolean;

    constructor(carPark: boolean = false, trafficAlert: boolean = false) {
        this.CarPark = carPark;
        this.TrafficAlert = trafficAlert;
    }

    public reset(): void {
        this.CarPark = false;
        this.TrafficAlert = false;
    }
}

export class GoogleMapModel {
    Boundingbox: IBoundingBoxModel;
    CarPark: boolean;
    TrafficAlert: boolean;

    constructor(boundingBox: IBoundingBoxModel, carPark: boolean, trafficAlert: boolean) {
        this.Boundingbox = boundingBox;
        this.CarPark = carPark;
        this.TrafficAlert = trafficAlert;
    }
}

export class GoogleMapMarkerData {
    id: number;
    latLng: ILatLng;
    placeName: string;
    index: number;
    itemIndx: number;
    type: MarkerType;
    draggable: boolean;

    draggedLatLng: ILatLng;
}
